
export const escaneoSlice = (set,get) => ({
    formatearFecha: (fecha) => {
        return fecha.toLocaleString('es-MX', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'UTC'
        });
    },
    obtenerEscaneo: async() => {
        if(get().datos.id != 0){
            await fetch("/p_escaneo",{
                method: "PATCH",
                headers:{"Content-Type": "application/json",},
                body: JSON.stringify({id:get().datos.id})
            })
            .then((res) => res.json())
            .then((data) => {
                console.log('Los dato',data);
                if(data.status == 1){
                    set({
                        id_cli:data.data[0][0].ID_CLI_ESC,
                        datos:{
                            ...get().datos,
                            consumo:data.data[0][0].CONSUMO_ESC,
                            total_gasto:data.data[0][0].GASTO_TOTAL_ESC.toString(),
                            total_descuento:data.data[0][0].TOTAL_DESCUENTO_ESC.toString(),
                            id_sucursal:data.data[0][0].ID_SUC_ESC,
                            motivo:data.data[0][0].MOTIVO_ESC || "",
                        },
                        nombre_cliente: `${data.data[1][0].NOMBRES_DP} ${data.data[1][0].APELLIDO_PATERNO_DP} ${data.data[1][0].APELLIDO_MATERNO_DP}`,
                        nombre_usuario: `${data.data[2][0].NOMBRE_USR} ${data.data[2][0].APELLIDO_PATERNO_USR} ${data.data[2][0].APELLIDO_MATERNO_USR}`,
                        fecha:get().formatearFecha(new Date(data.data[0][0].FECHA_CAMBIO_ESC)),
                        fecha_alta:get().formatearFecha(new Date(data.data[0][0].FECHA_ALTA_ESC)),
                        sucursalesEscaneo:get().sucursales.find((item) => { return item.value == data.data[0][0].ID_SUC_ESC }),
                    })

                    /* if(data.data[0][0].ID_SUC_ESC == 0 || data.data[0][0].ID_SUC_ESC == null){
                        set({ sucursalesEscaneo: get().sucursales[0] ?? null})
                    } */

                    let losCupones = [];
                    data.data[3].forEach((element) => {
                        losCupones.push({
                            id:element.ID_CUP,
                            title:element.TITULO_CUP,
                            type: element.TIPO_CUPON_CUP == 1 ? 'discount':'promotion',
                            value:element.VALOR_CUP,
                            descuento:element.DESCUENTO_CUP,
                            description:element.DESCRIPCION_CUP,
                            terms:element.TYC_CUP,
                        })
                    });
                    set({ cupones:losCupones })

                    set ({ descuentos: data.data[4].filter(x => x.TIPO_PROMOCION_CUP == 1)  })
                    set ({ promociones: data.data[4].filter(x => x.TIPO_PROMOCION_CUP == 2)  })

                }
            })
            .catch((error) => {
                console.log('Error',error);
            });
        }   
    },
    insertarEscaneo: () => {
        fetch("/p_escaneo",{
            headers:{"Content-Type": "application/json",},
            method: "PUT",
            body: JSON.stringify(get().datos)
        })
        .then((res) => res.json())
        .then((data) => {
            console.log('El dato',data);
            if(data.status == 1){
                // Success
                get().elNavigate(-1);
                get().limpiar();
            }
        })
        .catch((error) => {
            console.log('Error',error);
        });
    },
    enviarCodigoPromocion: () => {
        fetch("/p_enviar_codigo_promocion",{
            headers:{"Content-Type": "application/json",},
            method: "POST",
            body: JSON.stringify({id_cli:get().id_cli})
        })
        .then((res) => res.json())
        .then((data) => {
            console.log('El dato',data);
        })
        .catch((error) => {
            console.log('Error',error);
        });
    },
    insertarCuponCliente: async (id_cupon,codigo) => {
        let respuesta = await fetch("/p_insertar_cupon_cliente",{
            headers:{"Content-Type": "application/json",},
            method: "POST",
            body: JSON.stringify({id:get().datos.id,id_cupon:id_cupon,codigo:codigo})
        })
        
        let data = await respuesta.json();
        console.log('El dato',data);
        return data;
    }
})